
$(document).ready(function(){
  
   function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
  function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

if(getCookie('popup') != 'true' && window.location.href.indexOf('challenge#contact_form') == -1){
    $(".custom-popup").delay(2000).show();
    //  setCookie('popup', 'true', 1);
}
/* Checkout popup START CODE  */
$(document).on('click',"#ctm-checkout_jtpl",function(){
  $(".checkout-popup").addClass('checkout_model-open');
});
if($('.checkout-popup').length == 0){
   $('#CartDrawer-Checkout').show();
  $('#ctm-checkout_jtpl').hide();
}
   
$(document).on('click',".checkout_popup-close-btn , .checkout_no-thanks-btn",function(){
   window.location.href='/checkout';
  $(".checkout-popup").removeClass('checkout_model-open');
 // $('#CartDrawer-Checkout').show();
  //$('#ctm-checkout_jtpl').hide();
 
 //setCookie('checkout_popup', 'true', 1);
});
 
 $(document).mouseup(function (e) { 
            if ($(e.target).closest(".checkout-popup-inner").length === 0 && $(".checkout-popup").hasClass('checkout_model-open')) { 
         window.location.href='/checkout';
              $(".checkout-popup").removeClass('checkout_model-open');
           // setCookie('checkout_popup', 'true', 1);
          //  $('.checkout_popup-close-btn').trigger('click');
              
            } 
        }); 

// if(getCookie('checkout_popup') == 'true' ){
//    $('.checkout-popup').removeClass('checkout_model-open');
//     $('#CartDrawer-Checkout').show();
//     $('#ctm-checkout_jtpl').hide();

// }

/* Checkout popup END CODE  */

/* Welcome PopUp START CODE */
  $(".announcement-bar__message a").click(function(e){
   if($(this).attr('href').indexOf('#') >-1){
      e.preventDefault();
      $('.custom-popup').addClass('model-open').show(); 
    }
    
   
  });
$(".popup-close-btn ,.no-thanks-btn").click(function(e){
e.preventDefault();
  $(".custom-popup").removeClass('model-open');
  var data_url = window.location.href;
var main_url = data_url.split('?')[0];
console.log(main_url) ;
window.history.pushState({}, '', main_url);
  setCookie('popup', 'true', 1);
});



   $(document).mouseup(function (e) { 
    var recommended_data =  $(".recommendation-modal__container").html();
            if ($(e.target).closest(".custom-popup-inner").length === 0 && typeof recommended_data == 'undefined' ) { 
       $(".custom-popup").removeClass('model-open');
  var data_url = window.location.href;
var main_url = data_url.split('?')[0];
console.log(main_url) ;
window.history.pushState({}, '', main_url);
  setCookie('popup', 'true', 1);
  
              
            } 
        }); 

/*Welcome PopUp END CODE*/
 
  /** slider btn ****/
  $(window).on("load resize scroll",function(e){
var img_height = $('.about-multicol .multicolumn-card__image-wrapper').height();
var half_hight = img_height/2;
$('.about-multicol .slider-buttons').css("top",half_hight);
});
 /** slider btn End****/
 

  if($(window).width() > 1024){
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
   items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      if($('.mega-menu-image-slider.slick-initialized',item).length > 0){
        $('.mega-menu-image-slider',item).slick('unslick');
        $('.mega-menu-image-slider',item).slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          prevArrow:'<button type="button" class="slick-prev pull-left"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
         nextArrow:'<button type="button" class="slick-next pull-right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
        });
      }
       window.dispatchEvent(new Event("resize"));
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  });
  }else{
      let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
   items.forEach(item => {
    item.addEventListener("click", () => {
      if($('.mega-menu-image-slider.slick-initialized',item).length > 0){
        $('.mega-menu-image-slider',item).slick('unslick');
        $('.mega-menu-image-slider',item).slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          prevArrow:'<button type="button" class="slick-prev pull-left"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
         nextArrow:'<button type="button" class="slick-next pull-right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
        });
      }
    });
   });  
  }
              
   function eventFire(el, etype){
 console.log(el);
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}
$('.mega-menu-image-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  prevArrow:'<button type="button" class="slick-prev pull-left"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
 nextArrow:'<button type="button" class="slick-next pull-right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
});
  
/** One tab open at a time**/
$('.accordion details').click(function(){
      $(this).attr('open');
    $(this).parent('.accordion').siblings().find('details').removeAttr('open');
});
/** One tab open at a time END Code**/


$(".wall-calulator").click(function () {
  $(".success_msg , .wall_error").remove();
  var width = $.trim($("#wallpaper-width").val());
  var height = $.trim($("#wallpaper-height").val());
  if (
    width != undefined &&
    width != "" &&
    height != undefined &&
    height != ""
  ) {
    if (isNaN(width) == true || isNaN(height) == true) {
      $(
        '<p class="error wall_error">Please enter a valid number</p>'
      ).insertAfter($(this));
    } else {
      var roll = Math.ceil(width / 24);
      height = parseInt(height);
      var w1=24;
     if(height >=24 && height <=36){ height = 36;}
      else if(height >=37 && height <=48){  height = 48; }
      else if(height >=49 && height <=60){  height = 60; }
      else if(height >=61 && height <=72){  height = 72; }
      else if(height >=73 && height <=84){  height = 84; }
      else if(height >=85 && height <=96){  height = 96; }
      else if(height >=97 && height <=108){  height = 108; }
      else if(height >=109 && height <=120){  height = 120; }
      else if(height >=121 && height <=132){  height = 132; }
      else if(height >=133 && height <=144){  height = 144; }
      else{
         height = parseInt(height);
      }
      var message = `<p class="success_msg">Total required is: ${roll} rolls of ${w1}"x${height}"</p>`;
      $(".wallpaper-size-calculator").append(message);
    }
  } else {
    if (width == undefined || width == "") {
      $("#wallpaper-width").parent(".field").addClass("error");
    }
    if (height == undefined || height == "") {
      $("#wallpaper-height").parent(".field").addClass("error");
    }
    $(
      '<p class="error wall_error">Please fill the above fields</p>'
    ).insertAfter($(this));
  }
});
$("#wallpaper-height,#wallpaper-width").on("input", function () {
  $(this).parent(".field").removeClass("error");
});

/** Add attribute to the product form**/

$('.product-form__buttons button').click(function(e){
  $(this).parents('.product-form').attr('data-type',$(this).attr('data-type'));
  
  
});
/** Add attribute to the product form END HERE**/
    /*** convert select to ul li ***/
 

/*** product page covert select to ul li ***/

        $('.product-form__input--dropdown .select__select').each(function (index, element) {
      var selected_option = $('option:selected',this).text();
       var selected_option_val = $('option:selected',this).attr('data-value');
      if(selected_option_val.indexOf('sample') > -1){
        var select_id= $(this).attr('id');
        $('option:selected',this).removeAttr('selected');
        $('option:eq(2)',this).attr('selected', 'selected');
        eventFire(document.getElementById(select_id), 'change');
        var selected_option = $('option:selected',this).text();
       var selected_option_val = $('option:selected',this).attr('data-value'); 
      }
       var select_icon =$(this).next('.icon-caret');
        $(this).parent()
            .after()
            .append("<div class='scrollableList'><div class='selectedOption'></div><ul></ul></div>");
              $(select_icon).insertBefore($(this).parents('.select').find('.selectedOption'));  
        $(element).each(function (idx, elm) {
            $('option', elm).each(function (id, el) {
              if($(this).attr('data-value').indexOf('sample') == -1){
                $('.scrollableList ul:last').append('<li data-val="'+$(this).attr('data-value')+'" data-value="'+el.value+'">' + el.text + '</li>');
              }
              });
            $('.scrollableList ul').hide();
         
        });
        $('.scrollableList:last').children('div.selectedOption').text(selected_option).attr('data-selected_option_val',selected_option_val);
    });

    $('.selectedOption').on('click', function () {
        $(this).next('ul').slideToggle(200);
        $('.selectedOption').not(this).next('ul').hide();
    });

    $('.scrollableList ul li').on('click', function () {
        var selectedLI = $(this).text();
        $(this).parent().prev('.selectedOption').text(selectedLI).attr('data-selected_option_val',$(this).attr('data-val'));
        $(this).parent('ul').hide();
      var selected_value= $(this).attr('data-val');
      //alert(selected_value);
        $(this).parents('.select').find('select option:selected').removeAttr('selected');
      $(this).parents('.select').find('select option[data-value="'+selected_value+'"]').attr("selected", "selected");
       var select_id= $(this).parents('.select').find('select').attr('id');      
      eventFire(document.getElementById(select_id), 'change');
    });

    $('.scrollableList').show();
    $('.select__select').hide();

  
$(document).on("click", "ul.product-option-ul .init , .dropdown-icon", function() {
  $(this).closest("ul").find('.innerLi').toggle();
});

   /*** convert select to ul li END HERE***/
  $('html').click(function(event) {
    if ($(event.target).closest('.scrollableList ul, .scrollableList').length === 0) {
        $('.scrollableList ul').hide();
    }
});
      
  
  $(document).on("click", "ul.product-option-ul li:not(.init)", function() {
   $("ul.product-option-ul .innerLi li").removeClass('selected');
    $(this).addClass('selected');
    var selected_value = $.trim($(this).attr('data-value'));
    
    $(this).parents('ul').children('.init').html($(this).text());
  $(this).parents('ul').children('.init').attr('data-value',selected_value);    
    $(this).closest("ul").find('.innerLi').toggle();
     var select_id= $(this).parents('ul').attr('data-option'); 
  $('#SortBy option').removeAttr('selected');
  $('#SortBy option[value="'+selected_value+'"]').attr("selected", "selected");    
$('#SortBy').trigger('change');
  eventFire(document.getElementById('SortBy'), 'click');
  var url = window.location.href;
  var sort_by = 'sort_by='+selected_value;
  var href = new URL(window.location.href);
    if(window.location.href.indexOf('sort_by') > -1){
      href.searchParams.set('sort_by', selected_value);
 window.history.pushState({href: window.location.href}, '', href.toString());
      url = href.toString();
    }
    else{
       url =  url+'?'+sort_by;
         window.history.pushState({href: window.location.href}, '', url);
    }      
$.ajax({
        type: 'get',
        url:url,
        dataType: "html",
        success: function(result){ 
           $('#ProductGridContainer').html($(result).find('#ProductGridContainer'));
         
        }
    });
                 
});
  $('.sort_list').click(function(){
    $('.sort_icon').toggleClass('active');   
  });
  $('.sort_icon').click(function(){
   $('.innerLi').slideToggle();
    $('.sort_icon').toggleClass('active'); 
 });



// Prevent events from getting pass .popup
 $(document).on("click", function(event){
        var $trigger = $(".product-option-ul");
       if (!$trigger.is(event.target) && $trigger.has(event.target).length === 0) {
        $trigger.find('.innerLi').hide();
         $trigger.find('.sort_icon').removeClass('active');
        }            
    });
  


});  

// Calculator label icon popup

 $(".calculator_pop").on('click', function() {
  $(".custom-model-main").addClass('model-open');
}); 
$(".close-btn, .bg-overlay").click(function(){
  $(".custom-model-main").removeClass('model-open');
});
 $(document).mouseup(function (e) { 
            if ($(e.target).closest(".custom-model-inner").length === 0 ) { 
             $('.custom-model-main').removeClass('model-open');    
            } 
        }); 


